export const mapLatestScanJobsToHandoff = jobs => (jobs ?? []).map(job => ({
  jobId: job.jobId ?? '',
  strategy: job.strategy ?? '',
  itemType: job.itemType ?? undefined
})).filter(job => job.jobId && job.strategy);
//# sourceMappingURL=map-latest-scan-jobs.js.map